import styled from 'styled-components'
import Button from '../../atoms/Button/Button'
import Breakpoints from '../../theme/breakpoints'

export const NavigationButtons = styled.fieldset`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  border: none;

  @media (max-width: ${Breakpoints.tablet}) {
    flex-wrap: wrap;

    button {
      width: 100%;
    }
  }
`

export const NextButton = styled(Button)`
  align-self: flex-end;
  justify-content: center;
`
